import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import styled from 'styled-components'
import { MOBILE_BREAKPOINT_PX } from 'utils/mobileLayout'

export const PromptEditorRoot = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
`

export const PromptContentEditable = styled(ContentEditable)`
  min-height: 1.25rem;
  max-height: 6.25rem;
  overflow-y: auto;
  outline: 0;
  color: var(--foreground);
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.25rem;
  overflow-wrap: anywhere;
  white-space: pre-wrap;

  @media (min-width: ${MOBILE_BREAKPOINT_PX}px) {
    font-size: 0.875rem;
  }

  p {
    margin: 0;
  }

  ul,
  ol {
    margin: 0;
    padding-left: 1.5rem;
    list-style-position: outside;
  }

  ul {
    list-style-type: disc;
  }

  ol {
    list-style-type: decimal;
  }

  li {
    display: list-item;
  }

  .docchat-bold {
    font-weight: 700;
  }

  .docchat-italic {
    font-style: italic;
  }

  .docchat-code {
    font-family: monospace;
  }
`

export const PromptPlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  color: var(--muted-foreground);
  font-size: 1rem;
  line-height: 1.25rem;
  pointer-events: none;
  user-select: none;

  @media (min-width: ${MOBILE_BREAKPOINT_PX}px) {
    font-size: 0.875rem;
  }
`
